// Sentry debe cargarse primero (ver docs Sentry React)
import "./instrument";
import { createRoot } from "react-dom/client";
import { setSupabaseClient } from "@smarty/shared";
import { supabase } from "./lib/supabase";
import App from "./App.tsx";
import { devLog } from "@/lib/utils";
import { isAdminPath } from "@/config/routes.config";
import { initAppTheme } from "@/hooks/useAppTheme";

// Aplicar tema guardado ASAP (evita flash claro→oscuro en la primera pintura)
initAppTheme();

// Inyectar cliente Supabase para uso en shared (monorepo)
setSupabaseClient(supabase);

/** Admin = base-minimal + polaris. Tienda = index.css + polaris. Sin mezclar (ver docs/CONVENCION-CSS.md). */
async function loadStyles(): Promise<void> {
  const pathname = window.location.pathname;
  if (isAdminPath(pathname)) {
    await import("./styles/base-minimal.css");
    await import("./styles/polaris.css");
  } else {
    await import("./index.css");
    await import("./styles/polaris.css");
  }
}

loadStyles().then(() => {
  createRoot(document.getElementById("root")!).render(<App />);
});

// Registrar Service Worker SOLO EN PRODUCCIÓN
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        devLog.warn("✅ Service Worker registrado:", registration.scope);
      })
      .catch((error) => {
        devLog.error("❌ Error al registrar Service Worker:", error);
      });
  });
} else if (import.meta.env.DEV) {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => registration.unregister());
    });
  }
}
